const validatePan = (pan) => {
  pan = pan.toString();
  if (pan.length === 0) {
    return false;
  } else if (pan.length !== 16) {
    return false;
  }
  if (pan === "0000000000000000") {
    return false;
  }
  return isValidPan(pan);
};

const isValidPan = (pan) => {
  let sum = 0;
  let mul = 0;
  for (let i = 0; i < pan.length; i++) {
    if (i % 2 === 0) {
      mul = pan[i] * 2;
      if (mul >= 10) {
        mul = mul - 9;
      }
      sum += mul;
    }

    if (i % 2 !== 0) {
      mul = pan[i] * 1;
      if (mul >= 10) {
        mul = mul - 9;
      }
      sum += mul;
    }
  }
  //   this.wrongPan = sum % 10 !== 0;
  //   this.correctPan = sum % 10 === 0;
  return sum % 10 === 0;
};

export default validatePan;
